import { render } from "./SystemAiSettings.vue?vue&type=template&id=51d193df&scoped=true"
import script from "./SystemAiSettings.vue?vue&type=script&lang=js"
export * from "./SystemAiSettings.vue?vue&type=script&lang=js"

import "./SystemAiSettings.vue?vue&type=style&index=0&id=51d193df&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d193df"]])

export default __exports__